import styled from "styled-components";
import DownAngle from "../../../assets/img/icons/DownAngle.svg";
import CampaignkeywordAsider from "../../Campaigns/CampaignAssets/Components/CampaignkeywordAsider";
import CampaignAsiderNew from "../../Campaigns/CampaignAssets/Components/CampaignAsider";
import ProfileAsider from "../../Campaigns/Audience/People/ProfileAsider";
import { ICampaignsName } from "modules/Campaigns/interfaces";
import { closeOverlay, GLOBAL_ACTION, openOverlay } from "modules/GlobalActions";
import RecipientAsider from "./RecipientAsider";
import CreateContactSidebar from "modules/Campaigns/Audience/People/CreateContactSidebar";
import { useSelector } from "react-redux";
import store, { RootState } from "store";
import { useEffect, useState } from "react";
import ArticlePreviewSidebar from "modules/Content/Shared/ArticlePreviewSidebar";
import classNames from "classnames";
import { AssetType } from "modules/Campaigns/utils";

type Props = {
  isToggle?: boolean;
  className?: String;
  isToggleAsider?: boolean;
  isText?: boolean;
  keywordAsider?: boolean;
  CampaignAsider?: boolean;
  ProfileSidebar?: boolean;
  aToggle?: boolean;
  handleCancelCreateCampaign?: any;
  handleOnClickBrowsePeople?: any;
  onClickAudienceDone?: any;
  campaignKeywords?: Array<string>;
  setCampaignKeywords?: any;
  handleOnRemoveCampaignKeyword?: any;
  handleAddPeople?: any;
  campaignName?: string;
  setCampaignName?: any;
  handleCreateNewCampaign?: any;
  toggleCampaignSaveDisable?: any;
  setToggleCampaignSaveDisable?: any;
  selectedContactIds?: number[];
  selectedListIds?: number[];
  assetFlow?: boolean;
  rightMargin?: string;
  topMargin?: string;
  fitContent?: boolean;
  hideRecommendedList?: boolean;
  isPersonAdded?: any;
  enableScrollForContacts?: boolean;
  subtractWidth?: string;
  selectedCampaign?: string;
  disableMaxHeight?: boolean;
  templateAsider?: boolean;
  adhocAsider?: boolean;
  campaignItems?: ICampaignsName[];
  selectedContactNames?: string[];
  selectedListNames?: string[];
  page?: string;
  showRecipientAsider?: boolean;
  hideRecipientAsider?: (loadingState: boolean) => void;
  hideOverly?: boolean;
  rightSidebarId?: string;
  showEditContactAsider?: boolean;
  showEditContactAsiderHandler?: (value: boolean) => void;
  articleSidebarPreviewInDetailProfile?: boolean;
  inDetailProfile?: boolean;
  advancedSearch?: boolean;
  inCampaignSmartSourced?: boolean;
  searchTerms?: string[];
  inCreateCampaign?: boolean;
  inPublish?: boolean;
  inCreateNewList?: boolean;
  dataId?: string;
  selectAllFlag?: boolean;
  unselectedContactIdsState?: string[];
  recipientsApplyClickHandler?: (
    updatedListsState: any[],
    updatedContactsState: any[],
    updatedListObject: any[],
    updatedContactObject: any[]
  ) => void;
  sendToObjectCampaignAudience?: any[];
  setSendToObjectCampaignAudience?: (value: any[]) => void;
  addInSendTo?: (value: any) => void;
  idForRecommendedContacts?: string;
  assetType?: string;
};

const FloatingSidebarTwo: React.FC<Props> = ({
  isToggle,
  children,
  className,
  isToggleAsider,
  isText,
  keywordAsider,
  CampaignAsider,
  ProfileSidebar,
  aToggle,
  handleCancelCreateCampaign,
  handleOnClickBrowsePeople,
  onClickAudienceDone,
  campaignKeywords,
  setCampaignKeywords,
  handleOnRemoveCampaignKeyword,
  handleAddPeople,
  campaignName,
  setCampaignName,
  handleCreateNewCampaign,
  toggleCampaignSaveDisable,
  setToggleCampaignSaveDisable,
  selectedContactIds,
  selectedListIds,
  assetFlow = false,
  rightMargin,
  topMargin,
  fitContent,
  hideRecommendedList,
  isPersonAdded,
  enableScrollForContacts,
  subtractWidth,
  disableMaxHeight,
  selectedListNames,
  selectedContactNames,
  page,
  showRecipientAsider,
  hideRecipientAsider,
  hideOverly,
  rightSidebarId,
  showEditContactAsider,
  showEditContactAsiderHandler,
  articleSidebarPreviewInDetailProfile,
  inDetailProfile,
  advancedSearch,
  inCampaignSmartSourced,
  searchTerms,
  inCreateCampaign,
  inPublish,
  inCreateNewList,
  dataId,
  selectAllFlag,
  unselectedContactIdsState,
  recipientsApplyClickHandler,
  sendToObjectCampaignAudience,
  setSendToObjectCampaignAudience,
  addInSendTo,
  idForRecommendedContacts,
  assetType
}) => {
  const searchTermsInCampaign = useSelector((state: RootState) => state.assetDetails.searchTermsInCampaign);
  const allSourcesUnchecked = useSelector((state: RootState) => state.searchArticles.allSourcesUnchecked);
  const sourcedContent = useSelector((state: RootState) => state.searchArticles.sourcedContent);

  const excludedContent = useSelector((state: RootState) => state.searchArticles.excludedContent);
  const includedKeywords = useSelector((state: RootState) => state.searchArticles.includedKeywords);
  const excludedKeywords = useSelector((state: RootState) => state.searchArticles.excludedKeywords);
  const loading = useSelector((state: RootState) => state.searchArticles.loading);
  const isAIEmail = assetType === AssetType.AI_EMAIL
  const [noActiveExcludeSourcesState, setNoActiveExcludeSourcesState] = useState(false);
  const [globalPoolSelected, setGlobalPoolSelected] = useState(false);

  useEffect(() => {
    let noActiveExcludeKeywords = true;
    excludedContent.map(({ is_active }) => {
      if (is_active) {
        noActiveExcludeKeywords = false;
      }
    });
    if (noActiveExcludeKeywords) setNoActiveExcludeSourcesState(true);
    else setNoActiveExcludeSourcesState(false);

    let xiQGlobalPoolSelected = false;
    sourcedContent.map(({ is_active }, index) => {
      if (index === 0 && is_active) {
        xiQGlobalPoolSelected = true;
      }
    });
    if (xiQGlobalPoolSelected) setGlobalPoolSelected(true);
    else setGlobalPoolSelected(false);
  }, [sourcedContent, excludedContent, includedKeywords, excludedKeywords]);

  useEffect(() => {
    if (
      isToggle &&
      !window.location.pathname.includes("publish/") &&
      !window.location.pathname.includes("editionedit") &&
      !window.location.pathname.includes("campaigns")
    ) {
      if (!inDetailProfile) {
        openOverlay();
      }
    }
  }, [isToggle, inDetailProfile]);

  const scrollHandler = () => {
    store.dispatch({
      type: GLOBAL_ACTION.DETAIL_PROFILE_SCROLL_CHECK,
    });
  };

  const cancelClickHandler = () => {
    store.dispatch({
      type: GLOBAL_ACTION.CLOSE_ADVANCED_SEARCH_SIDEBAR,
    });
    closeOverlay();
  };
  const applyClickHandler = () => {
    store.dispatch({
      type: GLOBAL_ACTION.ADVANCED_SEARCH,
    });
  };


  return (
    <Wrapper
      rightMargin={rightMargin}
      topMargin={topMargin}
      fitContent={fitContent}
      advancedSearch={advancedSearch}
      {...(rightSidebarId ? { id: rightSidebarId } : {})}
      className={`${isToggle ? "open" : ""} ${className === undefined ? "" : className}`}
      data-id={dataId}
    >
      {/* toggle open class to view right sidebar */}
      <div className={classNames("expandable", { aiEmailDrawer: isAIEmail })}>
        {/* <div className="opener">{ProfileSidebar && <ProfileAsider aToggle={aToggle} />}</div> */}
        {/* Making this component general by accepting children from props*/}
        <div onScroll={scrollHandler} className={`right-sidebar ${page}`}>
          {children}
        </div>
        {CampaignAsider && (
          <CampaignAsiderNew
            aToggle={aToggle}
            onCancel={handleCancelCreateCampaign}
            handleOnClickBrowsePeople={handleOnClickBrowsePeople}
            campaignKeywords={campaignKeywords}
            setCampaignKeywords={setCampaignKeywords}
            handleOnRemoveCampaignKeyword={handleOnRemoveCampaignKeyword}
            campaignName={campaignName}
            setCampaignName={setCampaignName}
            handleCreateNewCampaign={handleCreateNewCampaign}
            toggleCampaignSaveDisable={toggleCampaignSaveDisable}
            setToggleCampaignSaveDisable={setToggleCampaignSaveDisable}
            assetFlow={assetFlow}
            selectedContactIds={selectedContactIds}
            selectedContactNames={selectedContactNames}
            selectedListIds={selectedListIds}
            selectedListNames={selectedListNames}
            handleAddPeople={handleAddPeople}
          />
        )}
        {keywordAsider && (
          <CampaignkeywordAsider
            inCreateNewList={inCreateNewList}
            inPublish={inPublish}
            inCreateCampaign={inCreateCampaign}
            isToggle={isToggleAsider}
            isText={isText}
            campaignKeywords={campaignKeywords}
            setCampaignKeywords={setCampaignKeywords}
            onClickAudienceDone={onClickAudienceDone}
            handleAddPeople={handleAddPeople}
            selectedContactIds={selectedContactIds}
            selectedListIds={selectedListIds}
            hideRecommendedList={hideRecommendedList}
            isPersonAdded={isPersonAdded}
            enableScrollForContacts={enableScrollForContacts}
            subtractWidth={subtractWidth}
            disableMaxHeight={disableMaxHeight}
            selectAllFlag={selectAllFlag}
            unselectedContactIdsState={unselectedContactIdsState}
            idForRecommendedContacts={idForRecommendedContacts}
          />
        )}
        {showRecipientAsider && (
          <RecipientAsider
            hideRecipientAsider={hideRecipientAsider}
            showRecipientAsider={showRecipientAsider}
            recipientsApplyClickHandler={recipientsApplyClickHandler}
            sendToObjectCampaignAudience={sendToObjectCampaignAudience}
            setSendToObjectCampaignAudience={setSendToObjectCampaignAudience}
            selectedContactIds={selectedContactIds}
            selectedListIds={selectedListIds}
            addInSendTo={addInSendTo}
          />
        )}
        {showEditContactAsider && (
          <CreateContactSidebar
            showEditContactAsiderHandler={showEditContactAsiderHandler}
            detailProfileAsider={true}
          />
        )}
        {articleSidebarPreviewInDetailProfile && (
          <ArticlePreviewSidebar articleSidebarPreviewInDetailProfile={articleSidebarPreviewInDetailProfile} />
        )}
        {advancedSearch && (
          <div className="footer-sider">
            <span className="footer-btn mr" onClick={cancelClickHandler}>
              Cancel
            </span>
            <span
              className={`${loading || allSourcesUnchecked ? "disabled" : ""} footer-btn filled-success`}
              onClick={applyClickHandler}
            >
              Apply
            </span>
          </div>
        )}
      </div>
    </Wrapper>
  );
};

export default FloatingSidebarTwo;

interface IWrapperProps {
  rightMargin?: string;
  topMargin?: string;
  fitContent?: boolean;
  advancedSearch?: boolean;
}
const Wrapper = styled("div") <IWrapperProps>`
  right: -3000px;
  position: fixed;
  min-width: 530px;
  top: 0;
  z-index: 15;
  transition: 0.5s;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    min-width: 410px;
  }
  .footer-sider {
    border-top: 1px solid #e4e4e4;
    display: flex;
    justify-content: flex-end;
    position: absolute;
    bottom: 0px;
    right: 0px;
    margin: 0 20px;
    width: 490px;
    padding: 20px 0;
    background: #fff;
    box-sizing: border-box;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      width: 375px;
    }
    .footer-btn {
      font-size: 16px;
      color: #27ce0a;
      padding: 3px 14px;
      font-family: "helveticaneuebold";
      font-weight: 700;
      border-radius: 17px;
      border: 1.56px solid#27CE0A;
      cursor: pointer;
      text-transform: capitalize;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 12px;
      }
      &.disabled {
        opacity: 0.5;
        pointer-events: none;
      }
      &.mr {
        margin-right: 15px;
      }
      &.filled-success {
        background-color: #27ce0a;
        color: #fff;
      }
    }
  }
  &.audience-sidebar {
    width: calc(100vw - 515px);
    min-width: none !important;
    .right-sidebar {
      width: 100% !important;
      padding: 50px 40px 30px 40px !important;
      /* width: calc(100vw - 515px) !important; */
    }
  }
  // &.new-asset-wrapper,
  &.detail-person-view {
    right: -1250px;
    min-width: 530px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      min-width: 410px;
    }

    .info-tooltip {
      &.advance-search-tip {
        width: 1150px !important;
        right: 0px !important;
        background: transparent;
        border-radius: 15px;
        transform: translateX(25px) !important;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
         width: 800px !important;
        }
        .ant-popover-content {
          margin-right: -20px;
          .ant-popover-arrow  {
            right: 2px !important;
          }
        }
        .ant-popover-inner {
          border-radius: 16px;
          .ant-popover-inner-content {
           padding: 28px 27px 14px 27px;
          }
        }
      }
    }

    .right-sidebar {
      /* width: 530px !important; */
      max-height: ${(props) => (props.advancedSearch ? "calc(100vh - 50px)" : "100vh")};
      overflow: auto;
      scrollbar-width: thin;
      scrollbar-color: #001760 #efefef;
      box-sizing: border-box;
      &::-webkit-scrollbar {
        width: 5px;
        height: 5px;
        border-radius: 5px;
      }
      /* Track */
      &::-webkit-scrollbar-track {
        background: #fff;
        margin-top: 10px;
        margin-bottom: 15px;
      }
      /* Handle */
      &::-webkit-scrollbar-thumb {
        background: #001760;
      }
      /* Handle on hover */
      &::-webkit-scrollbar-thumb:hover {
        background: #555;
      }
    }
  }
  &.open {
    right: ${(props) => (props.rightMargin ? (props) => props.rightMargin : "0px")};
    top: ${(props) => (props.topMargin ? (props) => props.topMargin : "")};
    transition: 0.5s;
  }
  .expandable {
    display: flex;
    align-items: flex-start;
    height: 100vh;
    background: #fff;
    box-shadow: 0px 0px 20px 0px rgb(0 0 0 / 10%);
    border-left: 1px solid #cfcfcf;
    float: right;
    width: ${(props) => (props.fitContent ? "fit-content" : "100%")};
    .opener {
      display: flex;
    }
    .aiEmailDrawer {
      .right-sidebar {
        padding: 20px 0px 0px 0px!important;
        .scroll-Wrapper-two {
         padding: 0px 20px;
        }
      }
    }
    .right-sidebar {
      width: ${(props) => (props.fitContent ? "fit-content" : "530px")};
      display: flex;
      flex-direction: column;
      height: 100vh;
      padding: 20px;
      padding-bottom: 0px;
      position: relative;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        //* updated width from 420px to 550px for small screen
        width: 410px;
        /* width: 530px;
        padding: 20px 35px; */
      }
      &.publish {
        ~ .wrapper-campaign-keyword {
          padding: 160px 40px 30px 40px !important;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            padding: 110px 40px 30px 40px !important;
          }
        }
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          //* updated width from 420px on publish page
          width: 410px;
          padding: 20px 10px;
        }
        + .wrapper-campaign-keyword {
          padding-top: 160px;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            padding-top: 110px;
          }
          .empty-spacer-class {
            @media all and (max-width: 1100px) {
              display: none; 
            }
          }
          .details {
            @media all and (max-width: 1100px) { 
              padding-top: 8px;
            }
            .name {
              @media all and (max-width: 1100px) {
                font-size: 10px;
                line-height: 10px;
                min-height: auto;
              }
            }
            .list-used-by {
              @media all and (max-width: 1100px) {
                margin-bottom: 3px;
              }
            }
          }
          .recommended-people {
            max-height: calc(100vh - 660px);
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
              max-height: calc(100vh - 540px);
              /* height: auto; */
            }
          }
        }
      }
      .header-section {
        .first-row {
          display: flex;
          justify-content: flex-end;
        }
        .second-row {
          padding-right: 6px;
          display: flex;
          flex-wrap: nowrap;
          justify-content: space-between;
          align-items: center;
          h4 {
            color: #424b50;
            font-size: 46px;
            font-family: "Roboto Slab", serif;
            line-height: 0.98;
            margin-bottom: 0;
            font-weight: bold;
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
              font-size: 32px;
            }
          }
          .scheduale-switch {
            span {
              font-family: "robotomedium", sans-serif;
            }
            span.active-text {
              font-family: "robotomedium", sans-serif;
              font-size: 16px;
              color: #717171;
              font-weight: 500;
              @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
                font-size: 12px;
              }
            }
          }
        }
      }
      .curated-list {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        overflow-y: auto;
        padding-left: 2px;
        padding-right: 2px;
        height: calc(100vh - 265px);
        font-family: "Roboto Slab", serif;
        scrollbar-color: #001760 transparent;
        scrollbar-width: thin;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          height: calc(100vh - 210px);
        }
        /* &::-webkit-scrollbar {
          display: none;
        } */
        &::-webkit-scrollbar {
          width: 4px;
          height: 4px;
          border-radius: 5px;
        }
        /* Track */
        &::-webkit-scrollbar-track {
          background: #fff;
          margin-top: 10px;
          margin-bottom: 15px;
        }
        /* Handle */
        &::-webkit-scrollbar-thumb {
          background: #001760;
        }
        /* Handle on hover */
        &::-webkit-scrollbar-thumb:hover {
          background: #555;
        }
        input {
          font-size: 16px !important;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            padding: 7px 12px;
            font-size: 12px !important;
          }
        }
        .input-with-upload {
          position: relative;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            padding-top: 4px !important;
          }
          .ant-select-multiple .ant-select-selector {
            /* overflow: hidden; */
          }
          .ant-select-selection-overflow {
            /* overflow: hidden; */
          }
          .ant-select-selection-placeholder {
            color: #c1c1c1;
            font-family: "robotoregular";
            font-style: italic;
            font-size: 16px;
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
              font-size: 12px;
            }
          }
          .ant-select-selection-search {
            margin-inline-start: 0px;
            overflow: hidden;
            input {
              min-width: 10px;
              min-width: max-content;
              line-height: 16px;
              @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
                height: 14px;
                padding: 0px;
                line-height: 12px;
              }
            }
          }
          .ant-upload-list {
            position: absolute;
            left: -5px;
            top: 11px;
            .anticon {
              float: left;
            }
            .ant-upload-list-item-card-actions {
              margin-top: 5px;
              .ant-upload-list-text-container {
                max-width: 410px;
              }
            }
          }
          div.ant-upload {
            position: absolute;
            right: 0;
            top: 35px;
            span.browse {
              border: 1.25px solid rgb(39, 206, 10);
              border-radius: 6px;
              font-size: 13px;
              color: rgb(39, 206, 10);
              font-weight: 700;
              font-family: "helveticaneuebold";
              padding: 6px 10px;
              letter-spacing: 0.5px;
            }
          }
        }
        .input-box {
          .ant-radio-group {
            margin-bottom: 16px;
            label {
              margin-right: 50px;
              .ant-radio-inner {
                border-color: #b0b0b0;
                &:after {
                  background-color: #b0b0b0;
                }
              }
            }
            span {
              color: #5e7079;
              font-size: 16px;
              font-weight: 500;
              font-family: "robotomedium";
              @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
                font-size: 12px;
              }
            }
          }
          .same-email {
            color: #5e7079;
            font-size: 16px;
            font-weight: 500;
            font-family: "robotomedium";
            margin-top: 10px;
            cursor: pointer;
            margin-bottom: -8px;
            float: left;
            width: 100%;
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
              line-height: 18px;
              font-size: 12px;
            }
          }
          .publish-label {
            color: #5e7079;
            font-size: 18px;
            font-family: "Roboto Slab", serif;
            padding-bottom: 8px;
            padding-top: 23px;
            font-weight: 600;
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
              /* padding-top: 25px; */
              font-size: 12px;
              /* padding-bottom: 6px; */
            }
          }
          .ant-select-selector {
            padding: 7px 15px;
            height: auto;
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
              padding: 7px 12px;
              border-radius: 6px;
              font-size: 12px;
              margin-top: 2px;
              line-height: 16px;
            }
            .ant-select-selection-item {
              color: #7e7e7e;
              font-size: 16px;
              font-weight: 600;
              font-family: "robotoregular";
              @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
                font-size: 12px;
                line-height: 16px;
              }
            }
            &.error-select {
              border: 2px solid #ffa112 !important;
            }
            &:after {
              @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
                line-height: 14px;
              }
            }
          }
          .error-select .ant-select-selector {
            border: 1px solid #ffa112 !important;
            box-shadow: none !important;
          }
          .error-select-publish .ant-select-selector {
            border: 1px solid #db3725 !important;
          }
          .ant-select-arrow {
            .anticon {
              background: url(${DownAngle});
              background-repeat: no-repeat;
              background-position: center;
              svg {
                opacity: 0;
              }
            }
            &:before {
              margin-top: -4px;
              content: "" !important;
              border-left: 1px solid #dddddd;
              display: block;
              height: 22px;
              margin-right: 8px;
              margin-left: -12px;
              @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
                margin-top: -2px;
                height: 18px;
              }
            }
          }
        }
        .rc-virtual-list .rc-virtual-list-holder {
          /* max-height: 270px !important; */
          /* @media all and (max-height: 650px) {
            max-height: 120px !important;
          } */
        }
        .compliance-check {
          background: rgba(0, 23, 96, 0.1);
          border: 1px solid rgba(0, 23, 96, 0.23);
          border-radius: 13px;
          padding: 20px 24px;
          margin-bottom: 10px;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            border-radius: 10px;
            padding: 12px 17px;
          }
          label {
            color: rgb(94, 112, 121);
            font-family: "robotoregular";
            font-size: 20px;
            font-weight: 600;
            cursor: pointer;
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
              font-size: 14px;
            }
            span {
              background-color: rgb(255, 255, 255);
            }
            > div {
              @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
                margin-top: 2px;
              }
            }
          }
          p {
            color: rgb(94, 112, 121);
            text-align: left;
            font-size: 16px;
            font-family: "robotoregular";
            clear: both;
            letter-spacing: -0.444444px;
            margin-bottom: 0;
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
              font-size: 11px;
            }
          }
        }
      }
      .bottom-floating-action {
        padding-top: 20px;
        padding-bottom: 20px;
        display: flex;
        justify-content: flex-end;
        background-color: #fff;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          padding-top: 10px;
          padding-bottom: 10px;
        }
        &.publish-footer {
          border-top: 1px solid #dadada;
          padding-top: 53px;
          z-index: 1;
          padding-right: 30px;
          padding-left: 40px;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            padding-top: 17px;
            padding-left: 30px;
          }
        }
      }
    }
  }
`;
